import { render, staticRenderFns } from "./ShareIt.vue?vue&type=template&id=02ac56a9&"
import script from "./ShareIt.vue?vue&type=script&lang=js&"
export * from "./ShareIt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports